import loggingService from '../services/util/loggingService'

var serviceName = 'BlmDataExportService'
var path = '/BlmDataExport/'
var isDebug = false

function get (http) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'GetLatestFiles', { responseType: 'arraybuffer' })
}

export default {
    get: get
}



// WEBPACK FOOTER //
// ./src/services/blmDataExportService.js